exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.student-profile .table th[data-v-2240574a] {\n    font-size: 14px;\n    padding: 5px 10px;\n    color: #fff;\n}\n.row.student-profile .card[data-v-2240574a] {\n    height: 100%;\n}\n.recent_notice ul li a[data-v-2240574a] {\n    line-height: 15px;\n}\n.today-routine small[data-v-2240574a] {\n    font-size: 12px;\n}\n", ""]);

// exports
